// Dependency
import { Link } from "gatsby";
import React, { useState, useEffect, useCallback } from "react";
import CloseIcon from "../../../images/close";
import SearchIcon from "../../../images/search";
import { Sheet, SheetTrigger, SheetContent, SheetClose } from "../../sheet";
import "./search.scss";
import Logo from "../../../images/logo";
import SearchProductCard from "../../cards/search-product-card";
import { useTranslation } from 'react-i18next';
import UtilsService from "../../../services/utils.service";


const Search = (props) => {
    const [searchResults, setSearchResults] = useState([])
    const [value, setValue] = useState('');

    const debounce = useCallback((fn, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => fn(...args), delay);
        };
    }, []);

    const debouncedSearch = useCallback(
        debounce((searchTerm) => {
            //onSearch(searchTerm);
            handleTextChange(searchTerm)
        }, 300),
        [debounce]
    );

    useEffect(() => {
        debouncedSearch(value);
    }, [value, debouncedSearch]);

    const handleResults = (props) => {
        setSearchResults(props.result)
    }

    const handleTextChange = (value) => {
        const inputText = value
        if (!inputText) {
            setSearchResults([])
            return
        }
        const hrq = window.hrq || [];
        hrq.push([
            "search",
            UtilsService.getHelloRetailKey("search", props.country),
            inputText,
            {
                format: "json",
                product_fields: "title,price,url,imgUrl,hierarchies,productNumber",
                return_filters: true,
                engine_options: {
                    product: {
                        current_count: 10,
                        start: 0
                    },
                    category: {
                        current_count: 4,
                        start: 0
                    }
                }
            },
            handleResults
        ]);
    }

    const { t } = useTranslation();

    return (
        <Sheet>
            <SheetTrigger className="cd-sheet-button cd-search-button">
                <SearchIcon />
                <span>{t("search.search")}</span>
            </SheetTrigger>
            <SheetContent className="cd-sheet-search" side={"top"}>
                <div className="cd-max-width cd-large-width">
                    <div className="cd-search-modal-header-wrapper">
                        <div className="cd-search-modal-logo">
                            <Logo />
                        </div>
                        <div className="cd-search-modal-input-wrapper">
                            <div className="cd-search-modal-header">
                                <SheetClose className="cd-search-close" onClick={() => { setSearchResults([]) }} >
                                    <CloseIcon />
                                    {t("search.close")}
                                </SheetClose>
                            </div>
                            <div className="cd-search-modal-grid">
                                <div className="cd-search-modal-input">
                                    <SearchIcon />
                                    <input autoFocus type="search" placeholder={t("search.search")} onChange={(e) => {
                                        setValue(e.target.value)
                                    }} />
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="cd-search-modal-content">
                        <div className="cd-search-modal-item cd-search-modal-right">
                            {searchResults.length > 0 &&
                                <div>
                                    <div className="cd-search-modal-grid">
                                        <h4>{t("search.suggestions")} </h4>
                                    </div>
                                    <div className="cd-search-modal-products">
                                        {searchResults.map((product, index) => {
                                            return (
                                                <div key={index} className="cd-search-modal-product">
                                                    <SearchProductCard labelText={props.labelText} labelBackground={props.labelBackground} color={props.color} product={product} />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            }
                            <SheetClose asChild>
                                <Link className="cd-search-modal-product" to={`/${props.country}/shop`}>
                                    {t("megaNav.allProducts")}
                                </Link>
                            </SheetClose>

                            {/* <SheetClose
                                className="cd-search-modal-button cd-search-modal-button-desktop"
                            >
                                Visa alla <span>26</span> artiklar
                            </SheetClose> */}
                            <div>
                                <div className="cd-search-modal-products cd-search-modal-blog">
                                    <div className="cd-search-modal-product cd-search-modal-article">
                                        <Link to={`/${props.country}/${t("search.pillowSlug")}`} className="cd-search-modal-category">
                                            <div className="cd-search-modal-category-wrapper cd-background-img">
                                                <img alt="" src="https://www.datocms-assets.com/50741/1695893213-flowpillow-usage-01.webp?auto=format&dpr=0.15&w=5504" />
                                                <div className="cd-background-overlay"></div>
                                                <div className="cd-search-modal-category-img">
                                                    <span>Flowpillows</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="cd-search-modal-product cd-search-modal-article">
                                        <Link to={`/${props.country}/${t("search.pressionSlug")}`} className="cd-search-modal-category">
                                            <div className="cd-search-modal-category-wrapper cd-background-img">
                                                <img alt="" src="https://www.datocms-assets.com/50741/1716978869-hand-massager_e-com_4x5_7.webp?auto=format&dpr=0.5&w=1600" />
                                                <div className="cd-background-overlay"></div>
                                                <div className="cd-search-modal-category-img">
                                                    <span>Flowpressions</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="cd-search-modal-product cd-search-modal-article">
                                        <Link to={`/${props.country}/${t("search.panelsSlug")}`} className="cd-search-modal-category">
                                            <div className="cd-search-modal-category-wrapper cd-background-img">
                                                <img alt="" src="https://www.datocms-assets.com/50741/1725695136-flowlight_large-white_063.webp?auto=format&dpr=0.15&w=5368" />
                                                <div className="cd-background-overlay"></div>
                                                <div className="cd-search-modal-category-img">
                                                    <span>Flowlight panels</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="cd-search-modal-product cd-search-modal-article">
                                        <Link to={`/${props.country}/${t("search.gunSlug")}`} className="cd-search-modal-category">
                                            <div className="cd-search-modal-category-wrapper cd-background-img">
                                                <img alt="" src="https://www.datocms-assets.com/50741/1712564712-flowgun-heat_usage_website-0002_flowlife_01_flowgun-hc_117.webp?auto=format&dpr=0.23&w=3527" />
                                                <div className="cd-background-overlay"></div>
                                                <div className="cd-search-modal-category-img">
                                                    <span>Flowguns</span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cd-search-modal-grid cd-search-modal-left">
                            <div className="cd-search-modal-item">
                                <h4>{t("search.popularSearches")}</h4>
                                <div className="cd-search-modal-links">
                                    <Link to={`/${props.country}/${t("search.pillowSlug")}`}>{t("search.pillow")}</Link>
                                    <Link to={`/${props.country}/${t("search.gunSlug")}`}>{t("search.gun")}</Link>
                                    <Link to={`/${props.country}/${t("search.feetSlug")}`}>{t("search.feet")}</Link>
                                    <Link to={`/${props.country}/${t("search.pressionSlug")}`}>{t("search.pression")}</Link>
                                    <Link to={`/${props.country}/${t("search.panelsSlug")}`}>{t("search.panels")}</Link>
                                    <Link to={`/${props.country}/${t("search.tensSlug")}`}>{t("search.tens")}</Link>
                                </div>
                            </div>
                            {/* <div className="cd-search-modal-item ">
                                <h4>Categories</h4>
                                <div className="cd-search-modal-categories">
                                    {searchResults.length > 0 && searchResults.map((product, index) => {

                                    })}
                                    <Link to="#" className="cd-search-modal-category">
                                        <div className="cd-search-modal-category-wrapper cd-background-img">
                                            <img alt="" src="https://www.datocms-assets.com/50741/1716978644-hand-massager_e-com_4x5_9-1.webp?auto=format" />
                                            <div className="cd-background-overlay"></div>
                                            <div className="cd-search-modal-category-img">
                                                <span>Flowlight panels</span>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="#" className="cd-search-modal-category">
                                        <div className="cd-search-modal-category-wrapper cd-background-img">
                                            <img alt="" src="https://www.datocms-assets.com/50741/1716978644-hand-massager_e-com_4x5_9-1.webp?auto=format" />
                                            <div className="cd-background-overlay"></div>
                                            <div className="cd-search-modal-category-img">
                                                <span>Flowlight panels</span>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="#" className="cd-search-modal-category">
                                        <div className="cd-search-modal-category-wrapper cd-background-img">
                                            <img alt="" src="https://www.datocms-assets.com/50741/1716978644-hand-massager_e-com_4x5_9-1.webp?auto=format" />
                                            <div className="cd-background-overlay"></div>
                                            <div className="cd-search-modal-category-img">
                                                <span>Flowlight panels</span>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="#" className="cd-search-modal-category">
                                        <div className="cd-search-modal-category-wrapper cd-background-img">
                                            <img alt="" src="https://www.datocms-assets.com/50741/1716978644-hand-massager_e-com_4x5_9-1.webp?auto=format" />
                                            <div className="cd-background-overlay"></div>
                                            <div className="cd-search-modal-category-img">
                                                <span>Flowlight panels</span>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div> */}
                        </div>
                        {/* <div className="cd-search-modal-button-wrapper">
                            <SheetClose
                                className="cd-search-modal-button"
                            >
                                Visa artiklar
                            </SheetClose>
                        </div> */}
                    </div>
                </div>

            </SheetContent>
        </Sheet>
    );

}

export default Search
